import api from 'api/api'
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import { downloadBlob } from 'utils/download-blob'

import { downloadBase64File } from "utils/donwload-base64-file"
import { FILE_TYPE } from "constants/index"

export const DOWNLOADING_PRODUCT_PRICES_LIST_PDF = "[PRODUCTS] DOWNLOADING PRODUCT PRICES LIST PDF"

export const GET_ALL_PRODUCTS = "[PRODUCTS] GET ALL PRODUCTS"
export const GET_PRODUCTS = "[PRODUCTS] GET PRODUCTS"
export const SEARCH_PRODUCTS = "[PRODUCTS] FIND PRODUCTS"
export const GET_MOVEMENTS_BY_PRODUCT = "[PRODUCTS] GET MOVEMENTS BY PRODUCT"
export const DOWNLOADING_VALUED_INVENTORY_REPORT = "[PRODUCTS] DOWNLOADING VALUED INVENTORY REPORT"
export const DOWNLOADING_PRODUCT_SHIPMENT_PDF = "[PRODUCTS] DOWNLOADING PRODUCT SHIPMENT PDF"
export const GET_ALL_SORTS = "[PRODUCTS] GET ALL SORTS"
export const GET_ALL_SUBSORTS = "[PRODUCTS] GET ALL SUBSORTS"
export const GET_ALL_BRANDS = "[PRODUCTS] GET ALL BRANDS"
export const GET_ALL_MATERIALS = "[PRODUCTS] GET ALL MATERIALS"
export const GET_ALL_PRESENTATIONS = "[PRODUCTS] GET ALL PRESENTATIONS"
export const GET_ALL_TYPEEXISTENCES = "[PRODUCTS] GET ALL TYPEEXISTENCES"
export const GET_UNIT_MEASURES_PRODUCT = "[PRODUCTS] GET UNIT MEASURES PRODUCT"
export const GET_DATA_PRODUCT = "[PRODUCTS] GET DATA PRODUCT"
export const GET_LAST_COST_PRICE = "[PRODUCTS] GET LAST COST PRICE"
export const STOCK_RODUCT = "[PRODUCTS] STOCK_RODUCT"
export const CRUD_PRODUCT = "[PRODUCTS] CRUD PRODUCT"
export const CRUD_SORT = "[PRODUCTS] CRUD SORT"
export const CRUD_SUBSORT = "[PRODUCTS] CRUD SUBSORT"
export const CRUD_BRAND = "[PRODUCTS] CRUD BRAND"
export const CRUD_MATERIAL = "[PRODUCTS] CRUD MATERIAL"
export const CRUD_PRESENTATION = "[PRODUCTS] CRUD PRESENTATION"
export const CRUD_TYPEEXISTENCE = "[PRODUCTS] CRUD TYPEEXISTENCE"

export function getAllProducts() {
  const request = api.get(`/producto/todos`)
  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_ALL_PRODUCTS,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function getProducts({
  page = 1,
  pageSize = 10,
  productType = '',
  status = '',
  skipStore = false,
  storeId = '',
  branchId = '',
  stock = '',
  search = '',
  order = 'desc',
  sortId = '',
  subSortId = '',
}) {
  const request = api.get(`/producto/registros`, {
    params: {
      page,
      por_pagina: pageSize,
      tipo_producto: productType,
      estado: status,
      omitir_almacen: skipStore,
      almacen_id: storeId || undefined,
      branch_id: branchId || undefined,
      stock: stock,
      busqueda: search,
      orden: order,
      clase_id: sortId || undefined,
      sub_clase_id: subSortId || undefined,
    }
  })
  return dispatch => {
    dispatch({ type: GET_PRODUCTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({
        type: GET_PRODUCTS,
        payload: {
          loading: false, ...(
            pageSize == 0
              ? { detalles: response.data, totalRegistros: response.data?.length }
              : { ...response.data }
          )
        }
      })
    }).catch((error) => {
      dispatch({ type: GET_PRODUCTS, payload: { loading: false } })
      console.log(error);
    })
  }
}

export function searchProducts({ productType = '', status = '', limit = 50, search = '', skipStore = false, onlyContabilized = false, branchId = '' }) {
  if (!search || !search?.trim()) {
    return (dispatch) => {
      dispatch({ type: SEARCH_PRODUCTS, payload: { loading: false, data: [] } });
    };
  }
  const request = api.get(`/producto/buscar-productos`, {
    params: {
      tipo_producto: productType,
      estado: status,
      limite: limit,
      busqueda: search,
      omitir_almacen: skipStore,
      solo_contabilizados: onlyContabilized,
      // Las unidades de medida se registran por sucursal, asi que sin esto el
      // backend devuelve la misma unidad repetida una vez por cada sucursal en la
      // que el producto esta dado de alta y el selector la muestra repetida.
      branch_id: branchId || undefined
    }
  })
  return (dispatch) => {
    dispatch({ type: SEARCH_PRODUCTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: SEARCH_PRODUCTS, payload: { loading: false, data: response.data.detalles } })
    }).catch((error) => {
      dispatch({ type: SEARCH_PRODUCTS, payload: { loading: false, data: [] } })
      toast.error("Error interno. No se pudo consultar los productos")
      console.log(error)
    })
  }
}

export function downloadValuedInventoryReportPdf({ priceType = 'precioventa', search = '' }) {
  const request = api.get(`/producto/pdf-reporte-inventario-valorizado`, {
    params: {
      tipo_precio: priceType,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_VALUED_INVENTORY_REPORT, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.PDF,
        file: response.data.archivo
      })
      toast.success('Se descargó el PDF.')
      dispatch({ type: DOWNLOADING_VALUED_INVENTORY_REPORT, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_VALUED_INVENTORY_REPORT, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el PDF.')
      console.error(error)
    })
  }
}

export function downloadValuedInventoryReportExcel({ priceType = 'precioventa', search = '' }) {
  const request = api.get(`/producto/excel-reporte-inventario-valorizado`, {
    params: {
      tipo_precio: priceType,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_VALUED_INVENTORY_REPORT, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.EXCEL,
        file: response.data.archivo
      })
      toast.success('Se descargó el Excel.')
      dispatch({ type: DOWNLOADING_VALUED_INVENTORY_REPORT, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_VALUED_INVENTORY_REPORT, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el Excel.')
      console.error(error)
    })
  }
}

export function downloadProductShipmentPdf(form) {
  const request = api.post(`/producto/pdf-envio-productos`, form)
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_PRODUCT_SHIPMENT_PDF, payload: true })
    request.then((response) => {
      if (response.data.status == 400) {
        toast.error(response.data.message)
        return
      }
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.PDF,
        file: response.data.archivo
      })
      toast.success('Se descargó el PDF.')
      dispatch({ type: DOWNLOADING_PRODUCT_SHIPMENT_PDF, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_PRODUCT_SHIPMENT_PDF, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el PDF.')
      console.error(error)
    })
  }
}

export function saveProduct(form) {
  const request = api.post(`/producto/guardar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_PRODUCT, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: true, data: response.data.data } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: false } })
      toast.error("Error inesperado, no se pudo guardar el producto")
      console.log(CRUD_PRODUCT, err)
    })
  }
}

export function updateStatusByProduct(form) {
  const request = api.post(`/cproducto`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_PRODUCT, payload: { loading: true } })
    toast.info('Actualizando producto...', { toastId: 'updateStatusByProduct', autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: true } })
        toast.success(response.data.message, { toastId: 'updateStatusByProduct', autoClose: 5000 })
      } else {
        toast.error(response.data.message, { toastId: 'updateStatusByProduct', autoClose: 5000 })
      }
      setTimeout(() => {
        dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: false } })
      toast.error("Error inesperado, no se pudo actualizar el producto", { toastId: 'updateStatusByProduct' })
      console.log(error)
    })
  }
}

export function deleteProduct(productId) {
  const request = api.post(`/eproducto`, { producto_id: productId })
  return (dispatch) => {
    dispatch({ type: CRUD_PRODUCT, payload: { loading: true } })
    toast.info('Borrando producto...', { toastId: 'deleteProduct', autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: true } })
        toast.success(response.data.message, { toastId: 'deleteProduct', autoClose: 5000 })
      } else {
        toast.error(response.data.message, { toastId: 'deleteProduct', autoClose: 5000 })
      }
      setTimeout(() => {
        dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_PRODUCT, payload: { loading: false, crud: false } })
      toast.error("Error inesperado, no se pudo borrar el producto", { toastId: 'deleteProduct' })
      console.log(error)
    })
  }
}

export function uploadProductImage(form) {
  const request = api.post(`/rimagenproducto`, form)
  return (dispatch) => {
    toast.info("Subiendo imagen del producto...", { toastId: "uploadProductImage", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_PRODUCT, payload: true })
        toast.update("uploadProductImage", { render: response.data.message, type: "success", autoClose: 5000 })
      } else {
        toast.update("uploadProductImage", { render: response.data.message, type: "error", autoClose: 5000 })
      }
      setTimeout(() => {
        dispatch({ type: CRUD_PRODUCT, payload: false })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_PRODUCT, payload: false })
      toast.update("uploadProductImage", { render: "Error al subir la imagen del producto", type: "error", autoClose: 5000 })
      console.log(CRUD_PRODUCT, err)
    })
  }
}

export function uploadProductFile(form) {
  const request = api.post(`/rfichatecnicaproducto`, form)
  return (dispatch) => {
    toast.info("Subiendo archivo del producto...", { toastId: "uploadProductFile", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_PRODUCT, payload: true })
        toast.update("uploadProductFile", { render: response.data.message, type: "success", autoClose: 5000 })
      } else {
        toast.update("uploadProductFile", { render: response.data.message, type: "error", autoClose: 5000 })
      }
      setTimeout(() => {
        dispatch({ type: CRUD_PRODUCT, payload: false })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_PRODUCT, payload: false })
      toast.update("uploadProductFile", { render: "Error al subir el archivo del producto", type: "error", autoClose: 5000 })
      console.log(CRUD_PRODUCT, err)
    })
  }
}

export function getMovementsByProduct(productId = 0) {
  const request = api.get(`/producto/movimientos-por-producto`, { params: { productId } })
  return (dispatch) => {
    dispatch({ type: GET_MOVEMENTS_BY_PRODUCT, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_MOVEMENTS_BY_PRODUCT, payload: { loading: false, data: response.data.data } })
      setTimeout(() => {
        dispatch({ type: GET_MOVEMENTS_BY_PRODUCT, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_MOVEMENTS_BY_PRODUCT, payload: { loading: false, data: null } })
      toast.error('Error inesperado. No se pudo obtener los movimientos del producto')
      console.log(error)
    })
  }
}

export function getLastCostPriceByProduct(idProduct, umId) {
  const request = api.get(`/ultimocosto/${idProduct}/${umId}`)
  return (dispatch) => {
    dispatch({ type: GET_LAST_COST_PRICE, payload: { loading: true, data: null } })
    toast.info("Obteniendo ultimo precio de costo...", { toastId: "getLastCostPrice", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.dismiss("getLastCostPrice")
        dispatch({ type: GET_LAST_COST_PRICE, payload: { loading: false, data: response.data.detalles } })
      } else {
        dispatch({ type: GET_LAST_COST_PRICE, payload: { loading: false, data: null } })
        toast.update("getLastCostPrice", { render: response.data.message, type: "error", autoClose: 4000 })
      }
      setTimeout(() => {
        dispatch({ type: GET_LAST_COST_PRICE, payload: { loading: false, data: null } })
      }, 50)
    })
  }
}

export function getUnitMeasuresByProduct({ productId = 0, storeId = 0 }) {
  const request = api.get(
    `/ums-producto?idproducto=${productId}&idalmacen=${storeId}`
  )
  return (dispatch) => {
    dispatch({ type: GET_UNIT_MEASURES_PRODUCT, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: GET_UNIT_MEASURES_PRODUCT, payload: { loading: false, data: response.data.detalles } })
      } else {
        dispatch({ type: GET_UNIT_MEASURES_PRODUCT, payload: { loading: false, data: null } })
      }
      setTimeout(() => {
        dispatch({ type: GET_UNIT_MEASURES_PRODUCT, payload: { loading: false, data: null } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: GET_UNIT_MEASURES_PRODUCT, payload: { loading: false, data: null } })
      toast.error("Error interno. No se pudo obtener las unidades de medida del producto")
      console.log(GET_UNIT_MEASURES_PRODUCT, error)
    })
  }
}

export function getAllSorts() {
  const request = api.get(`/clase`)

  return (dispatch) =>
    request.then((response) => {
      return dispatch({
        type: GET_ALL_SORTS,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function getAllSubSorts() {
  const request = api.get(`/subclase`)

  return (dispatch) =>
    request.then((response) => {
      return dispatch({
        type: GET_ALL_SUBSORTS,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function getAllBrands() {
  const request = api.get(`/marca`)

  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_ALL_BRANDS,
        payload: response.data.detalles,
      })
    })
}

export function getAllMaterials() {
  const request = api.get(`/material`)

  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_ALL_MATERIALS,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function getAllPresentation() {
  const request = api.get(
    `/presentacion`
  )

  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_ALL_PRESENTATIONS,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function getAllTypeExistences() {
  const request = api.get(
    `/tipoexistencia`
  )

  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_ALL_TYPEEXISTENCES,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function deleteSort(form) {
  const request = api.post(`/eclase`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_SORT, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_SORT, payload: false })
      }, 50)
    })
}

export function deleteSubSort(form) {
  const request = api.post(`/esubclase`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }

      dispatch({ type: CRUD_SUBSORT, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_SUBSORT, payload: false })
      }, 50)
    })
}

export function saveSort(form) {
  const request = api.post(
    `/rclase`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_SORT, payload: true, })
      setTimeout(() => {
        dispatch({ type: CRUD_SORT, payload: false })
      }, 50)
    })
}

export function saveSubSort(form) {
  const request = api.post(`/rsubclase`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
        getAllSubSorts()
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_SUBSORT, payload: true, })
      setTimeout(() => {
        dispatch({ type: CRUD_SUBSORT, payload: false })
      }, 50)
    })
}

export function updateSort(form) {
  const request = api.post(`/aclase`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_SORT, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_SORT, payload: false })
      }, 50)
    })
}

export function updateSubSort(form) {
  const request = api.post(`/asubclase`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_SUBSORT, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_SUBSORT, payload: false })
      }, 50)
    })
}

export function deleteBrand(form) {
  const request = api.post(`/emarca`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_BRAND, payload: true, })
      setTimeout(() => {
        dispatch({ type: CRUD_BRAND, payload: false })
      }, 50)
    })
}

export function saveBrand(form) {
  const request = api.post(`/rmarca`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }

      dispatch({ type: CRUD_BRAND, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_BRAND, payload: false })
      }, 50)
    })
}

export function updateBrand(form) {
  const request = api.post(`/amarca`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_BRAND, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_BRAND, payload: false })
      }, 50)
    })
}

export function updateStatusByBrand(form) {
  const request = api.post(`/cmarca`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        parseInt(form.estado) === 1
          ? toast.success(response.data.message)
          : toast.error(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_BRAND, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_BRAND, payload: false })
      }, 50)
    })
}

export function deleteMaterial(form) {
  const request = api.post(`/ematerial`, form)
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_MATERIAL, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_MATERIAL, payload: false })
      }, 50)
    })
}

export function deletePresentation(form) {
  const request = api.post(
    `/epresentacion`,
    form
  )
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_PRESENTATION, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_PRESENTATION, payload: false })
      }, 50)
    })
}

export function deleteTypeExistence(form) {
  const request = api.post(
    `/etipoexistencia`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_TYPEEXISTENCE, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_TYPEEXISTENCE, payload: false })
      }, 50)
    })
}

export function saveMaterial(form) {
  const request = api.post(
    `/rmaterial`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_MATERIAL, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_MATERIAL, payload: false })
      }, 50)
    })
}

export function savePresentation(form) {
  const request = api.post(
    `/rpresentacion`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_PRESENTATION, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_PRESENTATION, payload: false })
      }, 50)
    })
}

export function saveTypeExistence(form) {
  const request = api.post(
    `/rtipoexistencia`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_TYPEEXISTENCE, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_TYPEEXISTENCE, payload: false })
      }, 50)
    })
}

export function updateMaterial(form) {
  const request = api.post(
    `/amaterial`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_MATERIAL, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_MATERIAL, payload: false })
      }, 50)
    })
}

export function updatePresentation(form) {
  const request = api.post(
    `/apresentacion`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_PRESENTATION, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_PRESENTATION, payload: false })
      }, 50)
    })
}

export function updateTypeExistence(form) {
  const request = api.post(
    `/atipoexistencia`,
    form
  )
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_TYPEEXISTENCE, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_TYPEEXISTENCE, payload: false })
      }, 50)
    })
}

export function updateStatusBySort(form) {
  const request = api.post(
    `/cclase`,
    form
  )
  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        parseInt(form.estado) === 1
          ? toast.success(response.data.message)
          : toast.error(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_SORT, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_SORT, payload: false })
      }, 50)
    })
}

export function updateStatusBySubSort(form) {
  const request = api.post(
    `/csubclase`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        parseInt(form.estado) === 1
          ? toast.success(response.data.message)
          : toast.error(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_SUBSORT, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_SUBSORT, payload: false })
      }, 50)
    })
}

export function updateStatusByMaterial(form) {
  const request = api.post(`/cmaterial`, form)

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        parseInt(form.estado) === 1
          ? toast.success(response.data.message)
          : toast.error(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_MATERIAL, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_MATERIAL, payload: false })
      }, 50)
    })
}

export function updateStatusByPresentation(form) {
  const request = api.post(
    `/cpresentacion`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        parseInt(form.estado) === 1
          ? toast.success(response.data.message)
          : toast.error(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_PRESENTATION, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_PRESENTATION, payload: false })
      }, 50)
    })
}

export function updateStatusByTypeExistence(form) {
  const request = api.post(
    `/ctipoexistencia`,
    form
  )

  return (dispatch) =>
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        parseInt(form.estado) === 1
          ? toast.success(response.data.message)
          : toast.error(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      dispatch({ type: CRUD_TYPEEXISTENCE, payload: true })
      setTimeout(() => {
        dispatch({ type: CRUD_TYPEEXISTENCE, payload: false })
      }, 50)
    })
}
